import angular from 'angular';

// Kindly lifted from the StackOverflow discussion:
// http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
function escapeRegExp(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

export default function highlight() {
  // Mostly lifted from the now deprecated ui-utils lib: https://github.com/angular-ui/ui-utils
  return function(text, search, caseSensitive) {
    if (text && (search || angular.isNumber(search))) {
      text = text.toString();
      search = search.toString();
      if (caseSensitive) {
        return text.split(search).join(`<span class="ui-match">${search}</span>`);
      } else {
        return text.replace(new RegExp(escapeRegExp(search), 'gi'),
          '<span class="ui-match">$&</span>');
      }
    } else {
      return text;
    }
  };
}
